<template>
  <div class="apps-card">
    <div class="apps-card-container d-flex flex-column">
      <img :src="cardInfo.image.link" :alt="cardInfo.image.alt">
      <h3>{{ cardInfo.name }}</h3>
      <p>{{ cardInfo.description }}</p>
      <div class="d-flex justify-content-center mt-auto">
        <ButtonTransparent hyperlink :href="cardInfo.button.link" :text="cardInfo.button.text"/>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonTransparent from "@/components/common/ButtonTransparent";
export default {
  components: {ButtonTransparent},
  props: {
    cardInfo: {
      name: String,
      description: String,
      button: {
        text: String,
        link: String
      },
      image: {link: String, alt: String}
    }
  },
}
</script>
